module.exports = __webpack_public_path__ + "static/media/not_is_base.af9e3d1a.png";